export const BASE_URL = process.env.PUBLIC_URL;

export const API = {
  gs: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSuv6i8fJ2IWY6VtXNOjcQ2GbiF2uyOexBdKyzSfwMJPTaegSF4YKFBv17NDY_hYeXMJMxYZ_JGrQuS/pub?gid=0&single=true&output=tsv',
  mail: `${process.env.PUBLIC_URL}/mail.php`,
};

const baseTitle = 'PR会社｜ビルコム株式会社';
export const META_SCREENS = {
  home: {
    title: `無料PR力診断｜${baseTitle}`,
    breadcrumbsLevel: 0,
    ga: {},
  },
  result: {
    title: `無料PR力診断結果｜${baseTitle}`,
    breadcrumbsLevel: 1,
    ga: {},
  },
  registration: {
    title: `市場創造フェーズ診断｜${baseTitle}`,
    breadcrumbsLevel: 2,
    ga: {},
  },
  phaseresult: {
    title: `市場創造フェーズ診断結果｜${baseTitle}`,
    breadcrumbsLevel: 3,
    ga: {},
  },
  notfound: {
    title: `404 Not found｜${baseTitle}`,
    breadcrumbsLevel: 0,
    ga: {},
  },
};

export const LABEL = {
  appType: ('web' == process.env.APP_TYPE ? '(簡易版)' : '（訪問版）'),
};

export const MESSAGE = {
  home: {
    check: '未回答の項目があります。',
  },
  registration: {
    check: '入力項目に不足・誤りがあります。再度ご確認ください。',
    error: 'メール送信に失敗しました。',
  },
  validation: {
    required: '入力してください。',
    max: '%1$s文字以内で入力してください。',
    format: '入力に誤りがあります。',
    freedomain: 'フリーメールアドレスは使用できません。',
    agree: '同意してください。',
  },
};

export const FREE_DOMAINS = [
  'yahoo.co.jp',
  'gmail.com',
  'outlook.jp',
  'outlook.com',
  'hotmail.co.jp',
  'live.jp',
  'zoho.com',
  'protonmail.com',
  'mprotonmail.ch',
  'yandex.com',
  'mail.ru',
  'aol.jp',
  'biglobe.ne.jp',
  'hyper.cx',
  'loveboat.cx',
  'nakayoshi.cc',
  'pets-mail.com',
  'momo-mail.com',
  'mippi-mail.com',
  'youngpostman.net',
  'king-postman.com',
  'takechiyo.net',
  'shingor.net',
  'blackmail.cn',
  'hot.dog.cx',
  'mad.dog.cx',
  'sheep.dog.cx',
  'wolf.dog.cx',
  '117.cx',
  'cx.117.cx',
  'i.117.cx',
  'mail.117.cx',
  'pc.117.cx',
  'pet.117.cx',
  'ez.117.cx',
  'art.117.cx',
  'pop.117.cx',
  'sky.117.cx',
  '707.to',
  'art.707.to',
  'pop.707.to',
  'sky.707.to',
  'i.707.to',
  'mail.707.to',
  'pc.707.to',
  'pet.707.to',
  'to.707.to',
  'joker.117.cx',
  'pa.dog.cx',
  'smoug.net',
  'inbox.ru',
  'list.ru',
  'bk.ru',
  'mail.goo.ne.jp',
  'excite.co.jp',
  'tora.zzn.com',
  'hage.zzzn.com',
  'auone.jp',
  'estyle.ne.jp',
  'rediffmail.com',
  'renraku.in',
  'inbox.com',
  'usa.com',
  'myself.com',
  'post.com',
  'consultant.com',
  'dr.com',
  'europe.com',
  'techie.com',
  'accountant.com',
  'writeme.com',
  'iname.com',
  'contractor.net',
  'linuxmail.org',
  'uymail.com',
  'musician.org',
  'angelic.com',
  'icloud.com',
  'bitrix24.com',
  'cock.li',
  'airmail.cc',
  '8chan.co',
  'redchan.it',
  '420blaze.it',
  'aaathats3as.com',
  'cumallover.me',
  'dicksinhisan.us',
  'loves.dicksinhisan.us',
  'wants.dicksinhisan.us',
  'dicksinmyan.us',
  'loves.dicksinmyan.us',
  'wants.dicksinmyan.us',
  'goat.si',
  'horsefucker.org',
  'national.shitposting.agency',
  'nigge.rs',
  'tfwno.gf',
  'cock.lu',
  'cock.email',
  'firemail.cc',
  'hitler.rocks',
  'getbackinthe.kitchen',
  'memeware.net',
  'cocaine.ninja',
  'waifu.club',
  'confidesk.com',
  'contactoffice.be',
  'contactoffice.ca',
  'contactoffice.ch',
  'contactoffice.com',
  'contactoffice.co.uk',
  'contactoffice.de',
  'contactoffice.es',
  'contactoffice.fr',
  'contactoffice.it',
  'contactoffice.net',
  'contactoffice.nl',
  'contactoffice.us',
  'melmel.tv',
  'tokutoku.or.jp',
  'user.subject.jp',
  'drive.co.jp',
  'csc.jp',
  '1kw.jp',
  'fubako.com',
  'fact-mail.com',
  'keyakiclub.net',
  'otegami.com',
  'meritmail.net',
  'e-otegami.net',
  'cosmos-21.com',
  'lopox.com',
  'inter7.jp',
  'furime.jp',
  'yabumi.jp',
  'postpet.ddo.jp',
  'compass.jp',
  'ss.ts.st',
  'canmail.jp',
  'iis.to',
  'mail.realintegrity.net',
  'dxbeat.com',
  'a.orn.jp',
  'zacca.com',
  '55mail.cc',
  'puchinet.com',
  'disroot.org',
  'disr.it',
  'elude.in',
  'eludemaillhqfkh5.onion',
  'emailn.de',
  'emailn.eu',
  'emailn.ch',
  'emailn.at',
  'e-nautia.com',
  'e-nautia.email',
  'e-nautia.rocks',
  'iiiha.com',
  'iiiha.net',
  'iiiha.pro',
  'catsworld.at',
  'cyber-planet.net',
  'essiggurkerl.at',
  'everymail.at',
  'everymail.biz',
  'everymail.cc',
  'everymail.ch',
  'everymail.co.uk',
  'everymail.dk',
  'everymail.eu',
  'everymail.in',
  'everymail.mx',
  'everymail.net',
  'everymail.nl',
  'everymail.org',
  'everymail.org.uk',
  'everymail.ro',
  'everymail.tv',
  'everymail.ws',
  'family-events.com',
  'femaletalk.net',
  'flowerbabes.net',
  'galleryedition.com',
  'nightrider.at',
  'ready-to-love.com',
  'silentmoods.com',
  'webmagazin.info',
  'gmx.com',
  'gmx.us',
  'hushmail.com',
  'hushmail.me',
  'hush.com',
  'hush.ai',
  'mac.hush.com',
  'inbox.lt',
  'inbox.lv',
  'india.com',
  'mail2tor.com',
  'Mail2World.com',
  'barid.com',
  'mail.com.tr',
  'mail.bg',
  'mail.ee',
  'mailfence.com',
  'mail.md',
  'mailoo.org',
  'mailo.com',
  'perso.be',
  'brusseler.com',
  'emailasso.net',
  'inmano.com',
  'lavache.com',
  'monemail.com',
  'net-c.ca',
  'netcmail.com',
  'francemel.fr',
  'europamel.net',
  'africamel.net',
  'netc.lu',
  'net-c.nl',
  'net-c.it',
  'netc.it',
  'net-c.es',
  'net-c.cat',
  'net-c.pl',
  'netc.pl',
  'net-c.com',
  'netcourrier.com',
  'netc.eu',
  'net-c.fr',
  'netc.fr',
  'net-c.be',
  'net-c.lu',
  'ntymail.com',
  'openmailbox.org',
  'opmbx.org',
  'openaliasbox.org',
  'sori.net',
  'sina.co.ro',
  'smecher.co.ro',
  'steaua.co.ro',
  'tovarasi.co.ro',
  'ue.co.ro',
  'webmail.co.ro',
  'write.co.ro',
  'writeme.co.ro',
  'y.ro',
  'protonmail.ch',
  'protonmail.com',
  'pm.me',
  'aeterna.ru',
  'fotoplenka.ru',
  'fromru.com',
  'front.ru',
  'hotbox.ru',
  'hotmail.ru',
  'krovatka.su',
  'land.ru',
  'mail15.com',
  'mail333.com',
  'memori.ru',
  'newmail.ru',
  'nightmail.ru',
  'nm.ru',
  'photofile.ru',
  'pisem.net',
  'pochta.com',
  'pochta.ru',
  'pochtamt.ru',
  'pop3.ru',
  'qip.ru',
  'rbcmail.ru',
  'smtp.ru',
  'ziza.ru',
  '5ballov.ru',
  'rambler.ru',
  'lenta.ru',
  'autorambler.ru',
  'myrambler.ru',
  'ro.ru',
  'rambler.ua',
  'r0.ru',
  'rediffmail.com',
  'Safe-mail.net',
  'hellokitty.com',
  'mymelody.com',
  'kuririnmail.com',
  'hellokitty.com.my',
  'hellokitty.com.sg',
  'mymelody.com.my',
  'mymelody.com.sg',
  'seznam.cz',
  'email.cz',
  'post.cz',
  'teknik.io',
  'tocomail.com',
  'tutanota.com',
  'tutanota.de',
  'tutamail.com',
  'tuta.io',
  'keemail.me',
  'chewiemail.com',
  'clovermail.net',
  'expressmail.dk',
  'isonews2.com',
  'mail-on.us',
  'manlymail.net',
  'metadatamitigator.com',
  'offcolormail.com',
  'offensivelytolerant.com',
  'openmail.cc',
  'powdermail.com',
  'tightmail.com',
  'toothandmail.com',
  'tushmail.com',
  'vfemail.net',
  'vivaldi.net',
];



// WEBPACK FOOTER //
// ./src/js/constants.js